import { render } from "./PostSlider.vue?vue&type=template&id=0f21852e&scoped=true&ts=true"
import script from "./PostSlider.vue?vue&type=script&lang=ts"
export * from "./PostSlider.vue?vue&type=script&lang=ts"

import "./PostSlider.vue?vue&type=style&index=0&id=0f21852e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f21852e"]])

export default __exports__